
import React, { createContext, useContext } from 'react';
import { db } from '../firebase';
import { 
  collection, 
  getDocs, 
  getDoc, 
  doc, 
  query, 
  where, 
  addDoc, 
  updateDoc, 
  deleteDoc, 
  writeBatch 
} from 'firebase/firestore';

const DatabaseContext = createContext();

export const DatabaseProvider = ({ children }) => {
  const getCollection = async (name) => {
    const snap = await getDocs(collection(db, name));
    return snap.docs.map(d => ({ _id: d.id, ...d.data() }));
  };

  const getDocument = async (coll, id) => {
    const snap = await getDoc(doc(db, coll, id));
    if (snap.exists()) return { _id: snap.id, ...snap.data() };
    return null;
  };

  const queryCollection = async (coll, ...queryConstraints) => {
    const q = query(collection(db, coll), ...queryConstraints);
    const snap = await getDocs(q);
    return snap.docs.map(d => ({ _id: d.id, ...d.data() }));
  };

  const value = {
    getCollection,
    getDocument,
    queryCollection,
    db, // Export db for custom queries if needed
    // Add more wrappers as needed
  };

  return (
    <DatabaseContext.Provider value={value}>
      {children}
    </DatabaseContext.Provider>
  );
};

export const useDatabase = () => {
  const context = useContext(DatabaseContext);
  if (!context) throw new Error('useDatabase must be used within a DatabaseProvider');
  return context;
};
